// DOMNodePatcher.js
/*
 * This utility patches React's DOM methods to be more resilient to 
 * "removeChild not a child" errors that can happen in production
 */
const patchReactDOM = () => {
    if (typeof window === 'undefined' || !window.document) return;
    
    // Store the original removeChild method
    const originalRemoveChild = Node.prototype.removeChild;
    
    // Override with a safer version
    Node.prototype.removeChild = function(child) {
      try {
        // Check if the child is actually a child of this node
        if (child && this.contains(child)) {
          return originalRemoveChild.call(this, child);
        } else {
          console.warn('Prevented removeChild error - node is not a child');
          // Return a mock result to prevent errors
          return child;
        }
      } catch (e) {
        console.warn('Safe removeChild caught error:', e);
        // Return the child to prevent further errors
        return child;
      }
    };
    
    console.log('DOM Node methods patched for React compatibility');
  };
  
  export default patchReactDOM;